import React, { useContext, useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { GeneralContext } from "../GeneralProvider";
import { useToaster } from "../ToasterProvider";
import { useLanguage } from "../LanguageProvider";

const InvitationHandler = () => {
    const { getTranslation } = useLanguage();
    const { toastError } = useToaster();
    const { invitationCode } = useParams();
    const {
        getUserAuthorizations,
        setEmailInvitationCode,
        setEmailInvitationAcceptReject,
        setEmailInvitationType
    } = useContext(GeneralContext);
    const location = useLocation();
    const navigate = useNavigate();

    const userToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    const rememberMe = localStorage.getItem("rememberMe")  === true;
    useEffect(() => {
        setEmailInvitationCode(invitationCode)
        if (location.pathname.startsWith("/projects/invitation/accept")) {
            handleProjectInvitation();
            setEmailInvitationAcceptReject(1)
            setEmailInvitationType("project")
        }
        else if (location.pathname.startsWith("/projects/invitation/reject")) {
            handleProjectInvitation();
            setEmailInvitationAcceptReject(2)
            setEmailInvitationType("project")
        }
        else if (location.pathname.startsWith("/collaborators/invitation/accept")) {
            handleCollaboratorInvitation();
            setEmailInvitationAcceptReject(1)
            setEmailInvitationType("collaborators")
        }
        else if (location.pathname.startsWith("/collaborators/invitation/reject")) {
            handleCollaboratorInvitation();
            setEmailInvitationAcceptReject(2)
            setEmailInvitationType("collaborators")
        }
        else if (location.pathname.startsWith("/collaborators/invitation/new")) {
            handleNewCollaboratorInvitation();
            setEmailInvitationType("collaborators-new")
        }
    }, []);

    const handleAutoLogin = () => {
        const userID = JSON.parse(localStorage.getItem("user")).id || JSON.parse(sessionStorage.getItem("user")).id;
        if (userToken) {
            getUserAuthorizations(userToken, userID);
            navigate("/home");
        } else {
            toastError(getTranslation("invalidCredentials"));
        }
    };

    const handleProjectInvitation = async () => {
        try {
            if (userToken && rememberMe) {
                handleAutoLogin()
            }
            else {
                navigate('/')
            }
        } catch (error) {
            console.error("Proje daveti işlenirken hata oluştu", error);
        }
    };

    const handleNewCollaboratorInvitation = () => {
        navigate(`/register`);
    };

    const handleCollaboratorInvitation = async () => {
        try {
            if (userToken && rememberMe) {
                handleAutoLogin()
            }
            else {
                navigate('/')
            }
        } catch (error) {
            console.error("Collaborator daveti işlenirken hata oluştu", error);
        }
    };

    return (
        <div>
            Davet işleniyor, lütfen bekleyiniz...
        </div>
    );
};

export default InvitationHandler;
